<div
	*ngIf="coacheeProfileController.coachee$ | async as coachee"
	class="grid grid-cols-1 grid-rows-2 md:grid-rows-1 md:grid-cols-6 gap-2"
>
	<spr-coachee-profile-information-details
		[coachee]="coachee"
		(openChat)="controller.openCoacheeChat($event)"
		(openPlan)="controller.openCoacheePlan($event)"
		class="col-span-4"
	></spr-coachee-profile-information-details>
	<spr-coachee-profile-information-activities
		class="col-span-2"
	></spr-coachee-profile-information-activities>
</div>
